import { IZendeskArticle } from "@faire/web-api--source/com/faire/vendor/zendesk/IZendeskArticle";
import { IZendeskCategory } from "@faire/web-api--source/com/faire/vendor/zendesk/IZendeskCategory";
import { IZendeskSection } from "@faire/web-api--source/com/faire/vendor/zendesk/IZendeskSection";

import {
  BECOME_BRAND_ID,
  NAM_SELL_ON_FAIRE_ID,
  RETAILER_WHAT_IS_FAIRE_ID,
  WHERE_IS_FAIRE_AVAILABLE_ID,
} from "../articleIds";
import { ITopicPlaceholder } from "../types/topics";

const fakeArticleName = "Getting started";

const placeholderArticles = [
  IZendeskArticle.build({
    id: Number(RETAILER_WHAT_IS_FAIRE_ID),
    section_id: 360000000000,
    name: "How do I start buying on Faire?",
    body: `If you’re buying inventory for a brick-and-mortar store, online shop, or pop-up shop, you can sign up for free! When you join as a...`,
  }),
  IZendeskArticle.build({
    id: Number(WHERE_IS_FAIRE_AVAILABLE_ID),
    section_id: 360000000000,
    name: "Where is Faire available?",
    body: `Faire is currently available in the following countries: United States (excluding US territories such as Puerto Rico, and the Virgin...`,
  }),
  IZendeskArticle.build({
    id: Number(BECOME_BRAND_ID),
    section_id: 360000000000,
    name: "How do I sell on Faire?",
    body: `Independent retailers from around the world come to Faire to discover new products and take advantage of benefits that help...`,
  }),
  IZendeskArticle.build({
    id: Number(NAM_SELL_ON_FAIRE_ID),
    section_id: 360000000000,
    name: "How much does it cost to sell on Faire?",
    body: `It’s free to join Faire, and you’ll only pay commission when we connect you with a new retailer through our marketplace.   How...`,
  }),
];

const placeholderArticleWithPreview = placeholderArticles.map((article) => {
  return {
    ...article,
    section_name: "FAQ",
    preview: article.body,
  };
});

const randomSection = (id: number) => {
  return {
    ...IZendeskSection.build({
      id,
      category_id: 360000000000,
      name: fakeArticleName,
    }),
    number_of_articles: 3,
    articles: placeholderArticles.slice(0, 3),
  };
};

const randomCategory = {
  ...IZendeskCategory.build({
    id: 360000000000,
    name: fakeArticleName,
  }),
  articles: placeholderArticles.slice(0, 3),
};

export const sectionsPlaceHolder = () => {
  return Array(4)
    .fill(null)
    .map((_, index) => randomSection(360000000000 + index));
};

export const categoryPlaceholder = randomCategory;

export const popularGuidesPlaceHolder = placeholderArticles.slice(0, 3);

export const guidesPlaceHolder = placeholderArticleWithPreview;

export const topicPlaceHolder: ITopicPlaceholder = {
  id: 360000000000,
  category_id: 360000000000,
  name: fakeArticleName,
  articles: placeholderArticleWithPreview,
};

export const articleBodyPlaceholder = `<section><p><strong>Vivamus fringilla ipsum?</strong></p> <p><span style="font-weight: 400;">In diam quam, faucibus in tellus sed, dignissim placerat dolor. Pellentesque lacinia nisl ipsum, tristique suscipit lacus lobortis id. Phasellus mollis justo ut justo feugiat volutpat. Pellentesque sed lacus ac velit luctus molestie. Fusce a laoreet ex, eget lacinia dolor. Fusce interdum neque sit amet aliquam euismod.</span></p> <p>&nbsp;</p> <p><strong>Neque porro quisquam est qui dolorem?</strong></p> <ol> <li style="font-weight: 400;"><span style="font-weight: 400;">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</span></li> <li style="font-weight: 400;"><span style="font-weight: 400;">Nulla tincidunt justo sagittis faucibus interdum.</span></li> <li style="font-weight: 400;"><span style="font-weight: 400;">Nunc fringilla consequat orci in fringilla. Praesent et malesuada lacus. Pellentesque ultrices risus vitae porttitor imperdiet.</span></li> <li style="font-weight: 400;"><span style="font-weight: 400;">Duis vitae libero augue. Phasellus sit amet dui nec sem tempus sollicitudin. Suspendisse fringilla metus a neque semper, ac sollicitudin sapien fringilla.</span></li> </ol> <p><span style="font-weight: 400;">Praesent aliquet dui eget diam fringilla:</span></p> <ul> <li style="font-weight: 400;"><span style="font-weight: 400;">At auctor ex molestie.</span></li> <li style="font-weight: 400;"><span style="font-weight: 400;">Pellentesque sodales feugiat lacus in mollis.</span></li> <li style="font-weight: 400;"><span style="font-weight: 400;">Aliquam eu accumsan felis. Duis vestibulum arcu eu viverra tempus.</span></li> </ul> <p>&nbsp;</p> <p><strong> Maecenas interdum consequat tristique?</strong></p> <p><span style="font-weight: 400;">Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Sed molestie massa tincidunt est malesuada, quis mollis ante consequat. Ut posuere ligula nisl, et facilisis metus sodales rutrum. Aliquam mollis enim ac est elementum luctus.</span></p></section>`;
